import React from 'react'
import { MEMBERS_BUNDLE_FINGERPRINT } from '../bundleFingerprint'

function safeErrorMessage(error) {
  const message = typeof error?.message === 'string' ? error.message : ''
  return /before initialization/i.test(message) ? 'render_dependency_not_initialized' : 'route_render_failed'
}

export default class MemberRouteErrorBoundary extends React.Component {
  state = { error: null, revision: 0 }
  static getDerivedStateFromError(error) { return { error } }
  componentDidCatch(error) {
    console.error('[members-route-error]', {
      event: 'route_render_failed',
      route: this.props.routeKey || 'unknown',
      bundleVersion: MEMBERS_BUNDLE_FINGERPRINT.otaVersion || 'unknown',
      buildFingerprint: MEMBERS_BUNDLE_FINGERPRINT.gitSha || 'unknown',
      errorName: error?.name || 'Error',
      safeMessage: safeErrorMessage(error),
    })
  }
  render() {
    if (!this.state.error) return this.props.children
    return <section className="mp-panel" role="alert"><div className="mp-panel__body"><h4>Unable to show this page</h4><p className="mp-text-muted">Your information is safe. Retry this page or reload Privana.</p><button type="button" className="mp-primary" onClick={() => this.setState(({ revision }) => ({ error: null, revision: revision + 1 }))}>Retry</button>{' '}<button type="button" className="mp-link" onClick={() => window.location.reload()}>Reload</button>{' '}<a className="mp-link" href={`/${this.props.clubCode}/dashboard`}>Back to Home</a></div></section>
  }
}
